import * as ActionTypes from './actionTypes'

export const updateActorFieldValue =(actorType,payload) => {
   
    return {
        type: ActionTypes.UPDATE_ACTOR_FIELD_VALUE,
        actorType,
        payload
    }
}
export const updateActorContactInfo =(actorType,payload) => {
   
    return {
        type: ActionTypes.UPDATE_ACTOR_CONTACT_INFO,
        actorType,
        payload
    }
}




// Form InitialiZation

export const InitializePartiesForm=(payload)=>{
    return{
        type:ActionTypes.INITIALIZE_PARTIES_FORM,
        payload
    }
}

export const CopyActorDetails=(copyFrom,copyTo)=>{
    return{
        type:ActionTypes.COPY_ACTOR_INFO,
        copyFrom,
        copyTo

    }
}
export const UpdateActorCopyStatus=(copyFrom,copyTo,isChecked)=>(dispatch)=>{
    dispatch({
        type:ActionTypes.ACTOR_COPIED_STATUS,
        copyFrom,
        copyTo,
        isChecked

    })
 
    if(isChecked)
    dispatch(CopyActorDetails(copyFrom,copyTo))
}

 

  

